/**
 * Run a callback once the shared Swiper bundle (lib/swiper.min.js) has executed.
 *
 * Every bundle is included with `async`, so the browser runs them in whatever order they finish
 * downloading - a slider component can be initialised by Alpine before Swiper exists. Checking
 * `typeof Swiper` and bailing out (what the timelines used to do) leaves the slider dead whenever
 * the network orders it that way. lib/swiper.js sets window.Swiper and then dispatches
 * "swiper:ready"; this waits for whichever of the two is already true.
 *
 * The callback receives Swiper and the module map, so a slider can pass exactly the modules it uses:
 *
 *   whenSwiper((Swiper, modules) => new Swiper(el, { modules: [modules.Navigation] }))
 *
 * @param {(Swiper: typeof import('swiper').default, modules: Record<string, unknown>) => void} callback
 */
export function whenSwiper(callback) {
    if (typeof window.Swiper === 'function') {
        callback(window.Swiper, window.SwiperModules || {})
        return
    }
    document.addEventListener('swiper:ready', () => callback(window.Swiper, window.SwiperModules || {}), { once: true })
}
